import React, { createContext, useContext, useMemo, useState } from "react";
import { getAuthToken, removeAuthToken } from "utils/helpers";
import { useGetUser } from "@store/actions/userActions";

export const AuthContext = createContext(null);
export const useAuthContext = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [authed, setAuthed] = useState(getAuthToken);
  const { data, loading: userLoading, error: userError } = useGetUser({ skip: !authed?.user });
  const user = authed?.user && !userError ? data?.user : null;
  const isSuperAdmin = Boolean(user?.isSuperAdmin);

  const doLogout = () => {
    setAuthed(null);
    removeAuthToken();
  };
  const state = useMemo(() => ({ authed, user, isSuperAdmin, userLoading, userError, setAuthed, doLogout }),
    [authed, user, isSuperAdmin, userLoading, userError]);
  return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
};
export default AuthProvider;
